// extracted by mini-css-extract-plugin
export default {"all-checkbox":"MenuListMulti_all-checkbox__VmRZ3","selected":"MenuListMulti_selected__+T-ys"};